import { FC, useState } from 'react';
import { Row, Text } from '~/commonComponents';
import { Popover } from '~/commonComponents/Popover/Popover';
import { Colors } from '~/themes/colors';

interface IActivityLevelInfoProps {
  activityLevel: string;
  isAvailable?: boolean;
}

const activityLevelDescriptions: Record<string, string> = {
  high: 'Active within the last 30 days',
  medium: 'Active within the last 31-120 days',
  low: 'Active more than 121 days ago',
};

const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);

export const ActivityLevelInfo: FC<IActivityLevelInfoProps> = ({
  activityLevel,
  isAvailable = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!activityLevel) {
    return null;
  }

  const textColor = isAvailable ? Colors.neutral_500 : Colors.neutral_300;
  const activeColor = isOpen ? Colors.neutral_600 : textColor;
  const description = activityLevelDescriptions[activityLevel] ?? '';

  const Target = () => (
    <span onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      <Text bold color={activeColor} textDecoration="underline">
        {capitalize(activityLevel)}
      </Text>
    </span>
  );

  const Content = () => (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <Text color={Colors.neutral_600} whiteSpace="nowrap">
        {description}
      </Text>
    </div>
  );

  return (
    <Row alignItems="center" gap={4} style={{ opacity: isAvailable ? 1 : 0.5 }}>
      <Text color={textColor}>Activity Level: </Text>
      <Popover Target={Target} Content={Content} trigger="hover" position="bottom" offset={12} />
    </Row>
  );
};
